// Used for complex comparison tables
$(document).ready(function () {
    $('.dataTable').each(function () {
        var table = $(this);
        var dataTable = table.DataTable({
            order: [[1, 'asc']],
            ordering: false,
            paging: false,
            fixedHeader: true,
            searching: false,
            colReorder: true 
        });

        // Update table columns based on checkbox state
        function updateTable() {
            var checkedColumns = [];
            var uncheckedColumns = [];

            table.find('.column-checkbox').each(function () {
                var columnIndex = parseInt($(this).closest('th').attr('data-dt-column'));

                if ($(this).is(':checked')) {
                    checkedColumns.push(columnIndex);
                    $(this).closest('.input_wrap').addClass('__active');
                } else {
                    uncheckedColumns.push(columnIndex);
                    $(this).closest('.input_wrap').removeClass('__active');
                }
            });

            // Apply __checked class to checked columns
            table.find('tbody tr').each(function () {
                var row = $(this);
                row.find('td').each(function (index) {
                    var td = $(this);
                    if (checkedColumns.includes(index + 1)) {
                        td.addClass('__checked');
                    } else {
                        td.removeClass('__checked');
                    }
                });
            });

            // Set the new order based on status: fixed column (0) + checked + unchecked
            var newOrder = [0].concat(checkedColumns, uncheckedColumns);

            // Apply new order to the DataTable
            dataTable.colReorder.order(newOrder);
        }

        // Trigger table updates on checkbox state change
        table.on('change', '.column-checkbox', function () {
            updateTable();
        });

        updateTable();
    });
});
